import React from "react";
import moment from "moment";
import { dateDifference, DateDiffTypes } from "../../../utils/date";
import companyInfo from "../../../themes/themes";
import makeStyles from "@material-ui/core/styles/makeStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  preList: { marginBottom: 0 },
  icon: { color: theme.palette.primary.main, minWidth: theme.spacing(5) },
}));

export default function Journey({ plan }) {
  const classes = useStyles();

  const theme = process.env.REACT_APP_THEME;

  const planDuration = dateDifference(
    moment(plan?.start),
    moment(plan?.end),
    DateDiffTypes.months
  );

  const journey = [
    <span>
      Mapped out your <b>cash flow</b> for the next {planDuration} months
    </span>,
    <span>
      Planned your <b>supply chain</b> for the next {plan?.numLines || 0} orders
    </span>,
    <span>
      Discovered your <b>unit economics</b>
    </span>,
  ];

  return (
    <React.Fragment>
      <Typography variant="body1" paragraph>
        The Growth Plan you’re about to explore is the culmination of a business
        optimization journey you embarked on with {companyInfo[theme]?.company}.
      </Typography>
      <Typography variant="body1">During this process, you</Typography>

      <List>
        {journey.map((text, i) => {
          return (
            <ListItem key={i}>
              <ListItemIcon className={classes.icon}>
                <PlayArrowIcon />
              </ListItemIcon>
              <ListItemText>{text}</ListItemText>
            </ListItem>
          );
        })}
      </List>
    </React.Fragment>
  );
}
